import { render, staticRenderFns } from "./ShortMessageDetails.vue?vue&type=template&id=39e1e292&scoped=true"
import script from "./ShortMessageDetails.vue?vue&type=script&lang=js"
export * from "./ShortMessageDetails.vue?vue&type=script&lang=js"
import style0 from "./ShortMessageDetails.vue?vue&type=style&index=0&id=39e1e292&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1e292",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39e1e292')) {
      api.createRecord('39e1e292', component.options)
    } else {
      api.reload('39e1e292', component.options)
    }
    module.hot.accept("./ShortMessageDetails.vue?vue&type=template&id=39e1e292&scoped=true", function () {
      api.rerender('39e1e292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ShortMessage/ShortMessageDetails.vue"
export default component.exports